import {Footer, QuizTable} from "../../components";


export function ListQuizPage() {
    return (
        <div className="container-fluid mt-5 p-3">
            <QuizTable/>
            <Footer/>
        </div>
    )
}
